import React, { useEffect } from "react";

export default function Forbidden() {
    useEffect(() => {
        let meta = document.querySelector('meta[name="robots"]');

        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "robots");
            document.head.appendChild(meta);
        }

        meta.setAttribute("content", "noindex, nofollow");

        return () => {
            meta.setAttribute("content", "index, follow");
        };
    }, []);

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.iconWrapper}>
                    <span style={styles.code}>403</span>
                </div>

                <h1 style={styles.title}>Access Denied</h1>

                <p style={styles.description}>
                    You do not have permission to access this page or perform
                    this action.
                </p>

                <div style={styles.actions}>
                    <button
                        type="button"
                        onClick={() => window.history.back()}
                        style={styles.primaryButton}
                    >
                        Go Back
                    </button>

                    <a href="/" style={styles.secondaryButton}>
                        Return Home
                    </a>
                </div>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f8fafc",
        fontFamily:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },

    card: {
        width: "100%",
        maxWidth: "520px",
        background: "#ffffff",
        borderRadius: "22px",
        padding: "48px 40px",
        textAlign: "center",
        border: "1px solid #e5e0d3",
        boxShadow:
            "0 24px 48px -20px rgba(25,24,23,0.25)",
    },

    iconWrapper: {
        width: "96px",
        height: "96px",
        margin: "0 auto 24px",
        borderRadius: "50%",
        background: "#fffbeb",
        border: "1px solid #fed7aa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    code: {
        color: "#0f172a",
        fontSize: "28px",
        fontWeight: 700,
    },

    title: {
        margin: "0 0 12px",
        fontSize: "32px",
        fontWeight: 700,
        color: "#0f172a",
        fontFamily: "'Space Grotesk', Inter, sans-serif",
        letterSpacing: "-0.02em",
    },

    description: {
        margin: "0 auto 32px",
        maxWidth: "380px",
        color: "#64748b",
        lineHeight: 1.7,
        fontSize: "16px",
    },

    actions: {
        display: "flex",
        justifyContent: "center",
        gap: "12px",
        flexWrap: "wrap",
    },

    primaryButton: {
        border: "none",
        cursor: "pointer",
        background: "#0f172a",
        color: "#fff",
        padding: "12px 20px",
        borderRadius: "999px",
        fontWeight: 700,
        fontSize: "14px",
        minWidth: "140px",
    },

    secondaryButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
        background: "#f1f5f9",
        color: "#0f172a",
        padding: "12px 20px",
        borderRadius: "999px",
        fontWeight: 700,
        fontSize: "14px",
        minWidth: "140px",
        boxSizing: "border-box",
    },
};